import { ICoreContext } from '@msdyn365-commerce/core';
import { SimpleProduct, UnitOfMeasureConversion } from '@msdyn365-commerce/retail-proxy';
import { formatString } from './string-utils';

/**
 * Gets the non-breakoff unit of measure.
 * @param product The product.
 * @param unitConversions The unit conversions.
 * @returns The non-breakoff unit of measure.
 */
export function getNonBreakoffUOM(product: SimpleProduct | undefined, unitConversions: UnitOfMeasureConversion[] | undefined): string | undefined {
    // As per user request, no unit conversions are needed.
    // Return the product's default unit of measure directly.
    return product?.DefaultUnitOfMeasure;
}

/**
 * Gets the total conversion text.
 * @param context The context.
 * @param product The product.
 * @param unitConversions The unit conversions.
 * @param quantity The quantity.
 * @param breakoff Whether it's a breakoff.
 * @returns The total conversion text.
 */
export function getTotalConversionText(
    context: ICoreContext,
    product: SimpleProduct | undefined,
    unitConversions: UnitOfMeasureConversion[] | undefined,
    quantity: number,
    breakoff: boolean
): string | undefined {
    // As per user request, no unit conversions are needed.
    // Return a static string or a simple representation of quantity and default unit.
    if (!product || quantity === 0) {
        return undefined;
    }
    return formatString('{0} {1}', quantity, product.DefaultUnitOfMeasure);
}
